export const BidParamCategory = {
  Standing: "standing",
  Trader: "trader"
};
